import axios from 'axios';
import * as apiConstant from './apiConstant';

/****************************************
    leadership management API
    @author  UYM
    @date    2020.5.14
    @version 0.1    
 ******************************************/
class specialApi {
  static getAll(page, perpage) {
    var lang_key = localStorage.getItem('language');
    var url = '';
    page = page ? page : 0;
    if (perpage) url = `${apiConstant.API_URL}/special/all/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}?page=${page}&perpage=${perpage}`
    else url = `${apiConstant.API_URL}/special/all/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}?page=${page}`
    return axios({
      url,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }

  static getFind(id) {
    var lang_key = localStorage.getItem('language');

    return axios({
      url: `${apiConstant.API_URL}/special/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}/${id}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }

  static getTitleByLang(id) {
    var lang_key = localStorage.getItem('language');
    return axios({
      url: `${apiConstant.API_URL}/special/title/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}/${id}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
  }

}

export default specialApi;